import { logger } from "./logger";

// Convert HTML to plain text
export function htmlToText(html: string): string {
    if (!html) return "";
    
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      
      // Remove script and style elements first
      const scripts = doc.querySelectorAll("script, style");
      scripts.forEach(script => script.remove());
      
      // Get text content and normalize whitespace
      const text = doc.body.textContent || doc.body.innerText || "";
      
      // Clean up the text
      return text
        .replace(/\s+/g, " ")
        .replace(/\n\s*\n/g, "\n")
        .replace(/\n\s+/g, "\n")
        .replace(/\s+\n/g, "\n")
        .trim();
    } catch (error) {
      logger.warn("Failed to parse HTML to text:", error);
      // Fallback with regex
      return html
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
        .replace(/<!--[\s\S]*?-->/g, "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/\s+/g, " ")
        .replace(/\n\s*\n/g, "\n")
        .trim();
    }
  }
  
  export function formatOutlookBody(rawHtml: string): string {
    // Add <br> in front of every <p>
    let updated = rawHtml.replace(/<p>/gi, "<br><p>");
  
    // Find first <p> and last </p> positions
    const firstP = updated.indexOf("<p>");
    const lastP = updated.lastIndexOf("</p>");
  
    if (firstP === -1 || lastP === -1) {
      return rawHtml;
    }
  
    // Extract content from first <p> to last </p> (inclusive)
    return updated.slice(firstP, lastP + 4).trim();
  }